export const configuration = {
  BACKEND_URL: import.meta.env.VITE_BACKEND_BASE_URL,
  WS_PAY_URL: import.meta.env.VITE_WS_PAY_URL,
  FRONTEND_URL: import.meta.env.VITE_FRONTEND_BASE_URL,
};
